import { call, put, takeLatest } from 'redux-saga/effects'
import Raven from 'raven-js'
import { FETCH_TOPICS } from './constants'
import { fetchTopics } from './actions'
import { apiFetchTopics } from './services'

function* fetchTopicWorker(action) {
  try {
    let response = yield call(apiFetchTopics, action.deviceId)

    if (Array.isArray(response)) {
      response = response.filter((item) => item.contentType !== 'guide')
      response = response.map((item) => ({
        ...item,
        contentId: item.contentKey,
        deviceId: item.phone_fk
      }))

      yield put(fetchTopics.success(response))
    }
  } catch (err) {
    console.error('failed to fetch trending topics', err)
    Raven.captureException(err)
    yield put(fetchTopics.failure())
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_TOPICS.REQUEST, fetchTopicWorker)
}
